<template>
  <!--  高度可以细微调整，overflow可以使页面滚动-->
  <div>
    <div class="pager" :style="{'height': detail ? '100vh' : '90vh'}">
      <div class="container" style="position: -webkit-sticky; position: sticky;position: -webkit-sticky">
        <div style="padding: 10px 20px">
          <div class="flex-y-bottom">
            <div class="bo-logo flex-grow-0">
              <img :src="serviceUrl" />
            </div>
            <div class="bo-title flex-grow-1">
              <div style=" width: 100%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ eu1.name }}</div>
              <div>{{sampleSpec ? sampleSpec + ' / ' : ''}}
                {{sampleType ?  sampleType + ' / ' : ''}}
                {{experimentalTotalNum ? experimentalTotalNum + '个样本' : ''}}
              </div>
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-grow-1">
              <span class="real-price">￥{{emkt.formatPrice(formalQuotePrice) }}</span>
              <span class="sale-price" v-if="formalQuotePrice !== standardPrice"><s>￥{{emkt.formatPrice(standardPrice)}}</s></span>
            </div>
            <div class="flex-grow-1 right">
              <span class="deliver-text">预计交付周期：</span>
              <span class="deliver-value">{{serviceWorkDaysSolution ? serviceWorkDaysSolution.workdays : 15}}个工作日</span>
            </div>
          </div>
        </div>
        <div class="advertising-banner" v-if="promotion && promotion.name">{{promotion.name}}</div>
        <div class="step-wrapper" v-if="!detail">
          <van-steps
              :active="stepNo"
              active-color="#5878FA"
              inactive-color="#979797"
              finish-icon="checked"
              active-icon="checked"
              inactive-icon="circle"
          >
            <van-step>样本类型</van-step>
            <van-step>其他参数</van-step>
            <van-step>确认方案</van-step>
          </van-steps>
        </div>
      </div>
      <div>
        <van-popup
            v-model="showSampleCategory"
            closeable
            round
            close-icon="close"
            :style="{ width: '98%', height: '40%' }"
            @close="closeSampleCategoryPopup"
        >
          <div class="pop-title"><span>样本分类</span></div>
          <div class="item-title"><span>样本类型</span></div>
          <div class="flex-row sample-wrapper">
            <div v-for="(item, index) in sampleCategoryOptArr" :key="index" class="flex-grow-1" v-if="item.dictValue !== '-'">
              <div :class="sampleCategoryItemChecked[index] ? 'radioTagChecked' : 'radioTag'"
                   @click="pickSampleCategory(index)">
                {{ item.dictValue}}
              </div>
            </div>
          </div>
          <div v-for="(category, k) in sampleCategoryOptArr" :key="k">
            <div v-if="sampleCategoryItemChecked[k]">
              <div class="item-title"><span>{{sampleCategoryOptArr[k].extraValue}}</span></div>
              <div class="flex-row sample-wrapper">
                <div v-for="(item, index) in sampleSubCategoryOptArr" :key="index" class="flex-grow-1" v-if="category.dictKey === item.parentId">
                  <div :class="subCategoryChecked[index] ? 'radioTagChecked' : 'radioTag'"
                       @click="pickSubCategory(index)">
                    {{ item.dictValue}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pop-button-wrap">
            <div class="pop-button" @click="closeSampleCategoryPopup">
              <span>确定</span>
            </div>
          </div>
        </van-popup>
      </div>
      <div style="height:80vh; overflow: auto;">
        <div v-if="stepNo === 0">
          <van-form>
            <div class="segment-wrap">
              <span class="group-title"> 样本信息</span>
              <div class="cell-group-wrap">
                <van-cell center title="是否具有传染性" title-class="cell-title">
                  <template #right-icon>
                    <van-switch v-model="infectionChecked" size="24" />
                  </template>
                </van-cell>
                <div class="warning-info" v-if="infectionChecked">
            <span>注意：根据相关法律规定，传染性生物样本需要严格管控，
              吉凯目前不具备处理传染性样本的实验条件，请您务必保证提供的生物样本为非传染性样本；
              若一旦发现您提供的生物样本具有传染性，吉凯将保留追究相应的刑事和民事责任的权利。
            </span>
                </div>
                <van-cell v-if="!infectionChecked">
                  <van-row gutter="2">
                    <van-col span="6">样本物种</van-col>
                    <van-col span="4" v-for="(item, index) in sampleSpecOptArr" :key="index"><div
                        :class="sampleSpecItemChecked[index] ? 'radioTagChecked' : 'radioTag'"
                        @click="pickSampleSpec(index)">
                      {{ item.chnName }}
                    </div></van-col>
                    <van-col span="2"></van-col>
                  </van-row>
                  <van-field
                      v-if="showOtherSampleSpecInput"
                      v-model="otherSampleSpecName"
                      placeholder="请输入其他物种名称"
                      ref="otherSampleSpecNameField"
                      :rules="[{ validator: validateOtherSampleSpecName, message: '请输入其他物种名称', trigger: 'onBlur' }]"
                      @change="handleOtherSpecNameChanged"
                  />
                </van-cell>
                <van-field
                    v-if="!infectionChecked"
                    label-class="form-label"
                    v-model="diseaseDirectionName"
                    is-link
                    readonly
                    label="疾病方向"
                    placeholder="请选择疾病方向"
                    ref="diseaseDirectionField"
                    :rules="[{ validator: validateDiseaseDirection, message: '请选择疾病方向', trigger: 'onBlur' }]"
                    @click="showDiseaseDirectionPicker = true"
                />
                <van-popup
                    v-model="showDiseaseDirectionPicker"
                    round
                    position="bottom"
                >
                  <van-picker
                      show-toolbar
                      :columns="diseaseDirectionOpts"
                      value-key="diseaseName"
                      @cancel="onCancelDiseaseDirection"
                      @confirm="onConfirmDiseaseDirection"
                  />
                </van-popup>
                <van-field
                    v-if="!infectionChecked"
                    label-class="form-label"
                    v-model="sampleCategory.label"
                    is-link
                    readonly
                    label="样本分类"
                    placeholder="请选择样本分类"
                    ref="sampleCategoryField"
                    :rules="[{ validator: validateSampleCategory, message: '请选择样本分类', trigger: 'onBlur' }]"
                    @click="showSampleCategoryPopup"
                />
                <van-field
                    v-if="!infectionChecked"
                    label-class="form-label"
                    v-model="sampleType"
                    label="样本类型"
                    placeholder="填写示例：癌或癌旁样本"
                    ref="sampleTypeField"
                    @change="handleChangeSampleType"
                    @blur="reSetPageScroll"
                    @focus="reSetPageScroll"
                    :rules="[{ validator: validateSampleType, message: '请填写样本类型' ,trigger: 'onBlur' }]"
                />
                <div class="warning-info" v-show="bizValidateMsg !== ''">
            <span>{{bizValidateMsg}}
            </span>
                </div>
<!--                <van-field-->
<!--                    v-if="!infectionChecked"-->
<!--                    label-class="form-label"-->
<!--                    v-model="deliveryTime"-->
<!--                    is-link-->
<!--                    readonly-->
<!--                    label="样本预计到达时间"-->
<!--                    label-width="120px"-->
<!--                    placeholder="请选择时间"-->
<!--                    ref="deliveryTimeField"-->
<!--                    :rules="[{ validator: validateDeliveryTime, message: '请填写样本预计到达时间' ,trigger: 'onBlur' }]"-->
<!--                    @click="showCal = true"-->
<!--                />-->
<!--                <van-calendar v-model="showCal" @confirm="onConfirmDeliveryTime" class="date-select"/>-->
              </div>
              <div
                  style="height: 30px; background-color: #fafafa"
                  v-if="!infectionChecked"
              ></div>
              <div class="cell-group-wrap" v-if="!infectionChecked">
                <van-cell center title="剩余样本返回">
                  <template #right-icon>
                    <van-switch v-model="returnMaterialChecked" size="24" @click="handleChangeReturnMaterial"/>
                  </template>
                </van-cell>
<!--                <van-cell v-if="returnMaterialChecked && !infectionChecked">-->
<!--                  <van-row gutter="2">-->
<!--                    <van-col span="6">运费</van-col>-->
<!--                    <van-col span="18"-->
<!--                    ><span style="color: #5878fa">300元（干冰运输）</span></van-col-->
<!--                    >-->
<!--                  </van-row>-->
<!--                </van-cell>-->
              </div>
              <div class="cell-group-wrap">
                <van-cell-group title="实验组及样本数" v-if="!infectionChecked">
                  <div style="padding: 0 20px; font-size: 14px" >
                    <div
                        v-for="(experimental, index) in experimentalGroup"
                        style="padding: 20px 0"
                    >
              <span class="cancel-default-style">
                <van-field
                    v-model="experimental.label"
                    placeholder="未命名"
                    style="float: left; width: 100px"
                    input-align="right"
                    @blur="handleChangeGroupName(index)"
                >
                </van-field>
                <i class="icon-font emkt-icon-xiugai" style="color: #5878fa; font-size: 16px"></i>
              </span>
                      <span>
                <i
                    class="icon-font emkt-icon-shanjian"
                    style="color: red; float: right; font-size: 16px"
                    @click="removeExperimental(index)"
                ></i>
              </span>
                      <span>
                <van-stepper
                    :min="currEu === specialEuTemplateNo(0) ? 0 : 3"
                    v-model.number="experimental.number"
                    style="float: right; margin-right: 10%"
                    class="stepper"
                    @focus="reSetPageScroll"
                    @blur="reSetPageScroll"
                    @overlimit="overLimit(currEu === specialEuTemplateNo(0) ? 0 : 3)"
                    @change="handleChangeGroupNum(index, currEu === specialEuTemplateNo(0) ? 0 : 3)"
                />
              </span>
                    </div>
                    <div
                        style="padding: 20px 0; margin-top: 10px"
                        @click="addExperimental()"
                    >
                      <span>增加实验组</span>
                      <span>
                <i
                    class="icon-font emkt-icon-zengjia"
                    style="color: #5878fa; float: right; font-size: 16px"
                    @click.stop="addExperimental()"
                ></i>
              </span>
                    </div>
                  </div>
                </van-cell-group>
                <van-cell-group title="生信分析对照组设置" v-if="!infectionChecked && !specialEuTemplateNo().includes(this.currEu)">
                  <div style="padding: 0 20px; font-size: 14px">
                    <div
                        v-for="(controlObject, index) in controlGroup"
                        style="padding: 20px 0 0 0; text-align: left"
                    >
              <span>
                <select
                    class="select-group"
                    style="margin-right: 10px"
                    v-model="controlObject.experimental"
                >
                  <option disabled selected value="0">请选择</option>
                  <option
                      v-for="(item, index) in experimentalGroup"
                      :value="item"
                  >
                    {{ item.label }}
                  </option>
                </select>
                <span>VS</span>
                <select
                    class="select-group"
                    style="margin-left: 10px"
                    v-model="controlObject.control"
                    @change="handleChangeExperimentalControl">
                  <option disabled selected value="0">请选择</option>
                  <option
                      v-for="(item, index) in experimentalGroup"
                      :value="item">
                    {{ item.label }}
                  </option>
                </select>
              </span>
                      <span>
                <i
                    class="icon-font emkt-icon-shanjian"
                    style="color: red; float: right; font-size: 16px"
                    @click="removeControlGroup(index)"
                ></i>
              </span>
                      <span> </span>
                    </div>
                    <div
                        style="padding: 15px 0 15px 0; margin-top: 10px"
                        @click="addControlGroup()"
                    >
                      <span>增加分析对照组</span>
                      <span>
                <i
                    class="icon-font emkt-icon-zengjia"
                    style="color: #5878fa; float: right; font-size: 16px"
                    @click.stop="addControlGroup()"
                ></i>
              </span>
                    </div>
                  </div>
                </van-cell-group>
              </div>
            </div>
          </van-form>
        </div>
        <!--      其它参数页面 -->
        <div style="width: 100%; margin-bottom: 20px" v-else-if="stepNo === 1">
          <div style="width: 100%">
            <div v-if="showProcessTech[0].show">
              <van-cell-group title="样本处理">
                <div class="g-body">
                  <div v-for="(item,index) in sampleProcessTech.ParaRemoveHAProtein" :key="index"
                       :class="(sampleProcessing.dictKey === item.dictKey || sampleProcessTech.ParaRemoveHAProtein[index].dictKey === showProcessTech[0].default) ? 's-self': 'g-self'"
                       @click="handleSampleProcessChecked(index)">
                    <!--                   todo 推荐标签样式-->
                    <div class="article">
                      <div class="flag flag-left" v-if="item.dictKey === 1">推荐</div>
                      <div style="padding: 10px">
                        <div class="main-title">
                          {{ item.dictValue }}
                        </div>
                        <div class="small-title">{{ item.extraValue }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-cell-group>
            </div>
            <div v-if="showProcessTech[1].show">
              <van-cell-group title="建库技术">
                <div class="g-body">
                  <div v-for="(item, index) in sampleProcessTech.ParaConstructionTech" :key="index"
                       :class="(databaseBuildings.dictKey === item.dictKey || sampleProcessTech.ParaConstructionTech[index].dictKey === showProcessTech[1].default) ? 's-self': 'g-self'"
                       @click="handleDatabaseBuildingChecked(index)"
                  >
                    <!--                   todo 推荐标签样式-->
                    <div class="article">
                      <div class="flag flag-left" v-if="item.dictKey === 6">推荐</div>
                      <div style="padding: 10px">
                        <div class="main-title">
                          {{ item.dictValue }}
                        </div>
                        <div class="small-title">{{ item.extraValue }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-cell-group>
            </div>
            <div v-if="showProcessTech[2].show">
              <div>
            <span
                style="
                position: relative;
                top: 15px;
                float: right;
                right: 20px;
                font-size: 14px;
                color: #5878fa;
              "
                @click="openPdfList"
            >查看示例报告</span
            >
                <van-cell-group title="生信分析">
                  <div class="g-body">
                    <div v-for="(item,index) in sampleProcessTech.ParaBioAnalysis" :key="index"
                         :class="(boSignalAnalysis.dictKey === item.dictKey || sampleProcessTech.ParaBioAnalysis[index].dictKey === showProcessTech[2].default)? 's-self': 'g-self'"
                         @click="handleBoSignalAnalysisChecked(index)"
                    >
                      <!--                   todo 推荐标签样式-->
                      <div class="article">
                        <div class="flag flag-left" v-if="item.dictKey === 1">免费</div>
                        <div style="padding: 10px">
                          <div class="main-title">
                            {{ item.dictValue }}
                          </div>
                          <div class="small-title">{{ item.extraValue }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </van-cell-group>
              </div>
            </div>
            <div v-if="currEu === specialEuTemplateNo(1)">
              <van-cell-group title="选择基因">
                <div style="padding: 0 20px; font-size: 14px">
                  <div
                      v-for="(item, index) in geneSelectionGroup"
                      style="padding: 20px 0"
                  >
                    <span style="margin-right: 5%">基因{{ index + 1 }}</span>
                    <span>
                  <input
                      type="text"
                      disabled
                      v-model="item.label"
                      style="width: 70%"
                  />
                </span>
                    <span>
                  <i
                      class="icon-font emkt-icon-shanjian"
                      @click="removeGeneSearchResult(index)"
                      style="
                      color: red;
                      float: right;
                      font-size: 16px;
                      padding-top: 5px;
                    "
                  ></i>
                </span>
                  </div>
                  <div
                      class="open-popup open-goods"
                      data-popup=".popup-gene-only"
                      readonly
                      unselectable="on"
                      style="padding: 20px 0"
                  >
                    <span>添加基因</span>
                    <span>
                  <i
                      class="icon-font emkt-icon-zengjia"
                      style="color: #5878fa; float: right; font-size: 16px"
                  ></i>
                </span>
                  </div>
                </div>
              </van-cell-group>
            </div>
          </div>
        </div>
        <!--      确认方案页面 -->
        <div v-else-if="stepNo === 2">
          <div class="segment-wrap">
            <span class="group-title">样本信息</span>
            <div class="cell-group-wrap">
              <van-cell>
                <van-row>
                  <van-col span="6" class="cell-label">样本物种</van-col>
                  <van-col span="18" class="cell-content">{{sampleSpec}}</van-col>
                </van-row>
              </van-cell>
              <van-cell>
                <van-row>
                  <van-col span="6" class="cell-label">疾病方向</van-col>
                  <van-col span="18" class="cell-content">{{diseaseDirectionName}}</van-col>
                </van-row>
              </van-cell>
              <van-cell v-if="productInfo.eu1 !== specialEuTemplateNo(0)">
                <van-row>
                  <van-col span="6" class="cell-label">样本分类</van-col>
                  <van-col span="18" class="cell-content">{{sampleCategory.label}}</van-col>
                </van-row>
              </van-cell>
              <van-cell>
                <van-row>
                  <van-col span="6" class="cell-label">样本类型</van-col>
                  <van-col span="18" class="cell-content">{{sampleType}}</van-col>
                </van-row>
              </van-cell>
            </div>
          </div>
          <div class="segment-wrap">
            <span class="group-title">实验分组及样本数</span>
            <div class="cell-group-wrap">
              <van-cell v-for="(experimental, index) in experimentalGroup" :key="index">
                <van-row>
                  <van-col span="6" class="cell-label">{{experimental.label}}</van-col>
                  <van-col span="18" class="cell-content">{{experimental.number}}</van-col>
                </van-row>
              </van-cell>
              <van-cell v-for="(item, index) in controlGroup" :key="index">
                <van-row>
                  <van-col span="6" class="cell-label">生信分析组{{index+1}}</van-col>
                  <van-col span="18" class="cell-content">{{item.experimental.label}} VS {{item.control.label}}</van-col>
                </van-row>
              </van-cell>
            </div>
          </div>
          <div class="segment-wrap" v-if="(currEu !== specialEuTemplateNo(0) && currEu !== specialEuTemplateNo(1))">
            <span class="group-title">其他参数</span>
            <div class="cell-group-wrap">
              <van-cell v-if="showProcessTech[0].show">
                <van-row>
                  <van-col span="6" class="cell-label">样本处理</van-col>
                  <van-col span="18" class="cell-content">{{sampleProcessing.dictValue}}</van-col>
                </van-row>
              </van-cell>
              <van-cell v-if="showProcessTech[1].show">
                <van-row>
                  <van-col span="6" class="cell-label">建库技术</van-col>
                  <van-col span="18" class="cell-content">{{databaseBuildings.dictValue}}</van-col>
                </van-row>
              </van-cell>
              <van-cell v-if="showProcessTech[2].show">
                <van-row>
                  <van-col span="6" class="cell-label">生信分析</van-col>
                  <van-col span="18" class="cell-content">{{boSignalAnalysis.dictValue}}</van-col>
                </van-row>
              </van-cell>
              <div v-if="geneSelectionGroup.length > 0">
                <van-cell v-for="(item, index) in geneSelectionGroup" :key="index">
                  <van-row >
                    <van-col span="6" class="cell-label">基因{{index+1}}</van-col>
                    <van-col span="18" class="cell-content">{{item.label}}</van-col>
                  </van-row>
                </van-cell>
              </div>

            </div>
          </div>
          <div class="segment-wrap">
            <span class="group-title">质量承诺</span>
            <div class="cell-group-wrap" style=" font-size: 12px; padding: 0 20px"
                 v-for="(item, index) in serviceWorkDaysSolution.qualityCommitment" :key="index">
              <div>{{index+1}}、{{item.nameList[0]}}</div>
              <div v-html="item.content"></div>
            </div>
          </div>
          <div class="segment-wrap">
            <span class="group-title">服务说明</span>
            <div class="cell-group-wrap" style=" font-size: 12px; padding: 0 20px"
                 v-for="(item, index) in serviceWorkDaysSolution.serviceComments" :key="index" >
              <div>{{index+1}}、{{item.nameList[0]}}</div>
              <div v-html="item.content"></div>
            </div>
          </div>
        </div>
        <!--      我是有底线的，无需修改什么。-->
        <div style="color: #D2D2D6; text-align: center;pointer-events:none;">
          <p style="font-size: 12px;margin-bottom: 50%">---我是有底线的---</p>
        </div>
      </div>
      <!--      页脚两个按钮，如无特殊情况暂时不要修改-->
      <div style="position: fixed; top: 90vh; width: 100%;height: 10vh; background: white" v-if="!detail">
        <div style="text-align: center;padding:10px 0" v-if="stepNo < 2">
          <van-button class="bottom-button"  style="color: #5878fa; height: 35px" @click="goBack">返回</van-button>
          <van-button class="bottom-button" v-bind:class="bizValidateMsg === '' ?'next-button-active':'next-button-inactive'" :disabled="infectionChecked" @click="nextStep">下一步</van-button>
        </div>
        <div v-else style="text-align:center;width: 100%; padding: 10px 5px 0 10px">
          <div style="margin-top: 20px; float: left; width: 10%" @click="jumpToCart">
            <van-badge :content="shoppingCartProductNumber" v-if="shoppingCartProductNumber !== 0"  class="badgev" style="float: right; margin: 0 2px 0 0; position: relative; top: -8px;"></van-badge>
            <div class="cart" style="width: 28px;height: 28px"></div>
          </div>
          <van-button class="bottom-button-small"  style="color: #5878fa;height: 35px" @click="goBack">返回</van-button>
          <van-button class="bottom-button-small" style="background: #5878fa; color: white;height: 35px" @click="gotoCart">{{text}}</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import wx from "wx";
import {mapMutations, mapState, mapGetters} from "vuex";
import Emkt from "../../emkt";
import StaticDoc from "../multiplex/StaticDoc";
import { Toast } from 'vant';
import {
  specialEuTemplateNo,
  paraffinEuTemplateNo,
  getSolutionInfoByOrderId, makeSureAsync, getSolutionInfoByCartItemId
} from "../../util/templateToUserData";
const RETURN_MATERIAL_EU_NO = 'EU000273'
export default {
  components: {StaticDoc},
  data() {
    return {
      result: null,
      detail: false,
      comeForm: false,
      showErr: false,
      text: '',
      puIdInit: -100,
      DiaEuTemplateNo: ['EU000331','EU000269','EU000334'],
      serviceUrl: "/emktResources/resocurces/img/merchandise/service.png",
      oldCartContent: Object.assign({}),
      shoppingCartProductNumber: null,
      stepNo: 0,
      currEu: '',
      currSku: {},
      // product理应从路由中取得产品名称。
      // TMT, 4D 可出现样本处理，其它不出现，sampleCategory.currSampleCategory不是‘体液样本’时，不出现样本处理
      // 只有DIA 2.0存在建库技术，若样本为体液类样本，DIA6级建库不可选， TODO 选择无需建库时，生信分析选项（4号位置）变为DeepDIA
      // shotgun时，step+2
      // 为PRM时，只有基因选择
      // 模拟样本处理（sampleProcessing），建库技术（databaseBuildings），生信分析（boSignalAnalysis）的选中值
      sampleProcessing: {},
      databaseBuildings: {},
      boSignalAnalysis: {},
      // 基因选择是一个数组类型
      geneSelectionGroup: [],
      // 实验组
      experimentalGroup: [{label:'实验组1', number :3},{label:'对照组2', number :3}],
      experimentalName: "",
      experimentalTotalNum: 0,
      // 对照组(control)和实验组(experimental)，数据结构： [{'experimental':{}, 'control':{}},{'experimental':{}, 'control':{}}...]
      controlGroup: [],
      controlName: "",
      sampleSpecItemChecked: [],
      sampleSpec: "" /* 样本物种 */,
      showOtherSampleSpecInput: false,
      otherSampleSpecName: "",
      infectionChecked: false,
      diseaseDirectionId: "",
      diseaseDirectionName: "",
      diseaseDirectionOpts: [],
      showDiseaseDirectionPicker: false,
      currSampleCategory: "",
      // 下面sampleCategory定义了三个属性，label为显示值（String），其它两个各自对应选择选项。
      sampleCategory: {},
      sampleType: "",
      showSampleCategory: false,
      sampleSpecOptArr: [{engName:"Mouse",chnName:"小鼠"}, {engName:"Rat",chnName:"大鼠"}, {engName:"Human",chnName:"人类"}, {engName:"其他",chnName:"其他"}],
      sampleCategoryOptArr: [],
      sampleSubCategoryOptArr: [],
      sampleCategoryItemChecked: [],
      subCategoryChecked: [],
      showCal: false,
      deliveryTime: "",
      returnMaterialChecked: false,
      //   技术分类(TechCategory):71001
      //   产品分类(ProductCategory):71002
      //   TechCategory: [],
      //   ProductCategory: [],
      // 样本参数-是否返还(ParaReturnMaterial):71003
      // 参数选择-是否去高丰度蛋白(ParaRemoveHAProtein):71004
      // 参数选择-建库技术(ParaConstructionTech):71005
      // 参数选择-生信分析(ParaBioAnalysis):71006
      sampleProcessTech: {
        ParaReturnMaterial: [],
        ParaRemoveHAProtein: [],
        ParaConstructionTech: [],
        ParaBioAnalysis: [],
      },
      showProcessTech :[],
      constructionTechEnable: [true,true,true],  //建库技术选项启用标志
      validateFlag: false,
      bizValidateMsg: '',
      // 方案信息
      boSolution: {
        children: [{}]
      },
      priceSolution: {},
      serviceWorkDaysSolution: {},
      solutionId: '',
      currTaxId: '10090',
      formalQuotePrice: '',
      standardPrice: '',
      materialReceive: {
        receiveType: 2,
        isReceived: 0,
        notReceivedType: 1,
        returnType: 2,
        expectArrivalDT: '',
        quoteItemNos: []
      },
      euTemplates: [],
      puTemplates: [],
      proteomicsSku: [],
      specPuTemplates: [],
      eus: [],
      eu1: {},
      eu2: {},
      pus1: [],
      pus2: [],
      groups: [],
      productInfo: Object.assign({}),
      promotion: Object.assign({})
    }
  },
  created () {
    this.getMeteData()
    this.initNormalFormData()
    if (this.$route.query.detail) {
      this.stepNo = 2
      this.detail = true
    }
  },
  updated() {
    let number = 0
    this.experimentalGroup.forEach( item => {
      number += item.number
    })
    this.experimentalTotalNum = number
    if (this.currEu === 'EU000048' && this.currEu === 'EU000046') {
      this.controlGroup = []
    }
    this.shoppingCartProductNumber = this.getNumberFromCart()
  },
  /**
   * @author AnyaParry
   * @description 在watch中的代码监控选择的基因，这个对象存在于store中。
   * 如需修改请找AnyaParry
   *
   */
  watch: {
    geneSearchResult: function (val) {
      let data = val["/Weapp/BoSolution"].data;
      let dictionary = Emkt.getEmktMetaData().dictionariesMap;
      data["taxName"] = dictionary[61033][data.taxId].dictValue;
      data["label"] = data["taxName"] + " / " + data["symbol"] + " / " + data["NMID"];
      this.geneSelectionGroup.push(data);
      console.log(data, '基因选择数据')
      this.handleChangeGene();
    },
  },
  mounted() {
    let comeFrom =  this.$route.query.comeFrom
    if (comeFrom === 'cart') {
      this.comeForm = true
      this.text = "保存修改"
      let that = this
      getSolutionInfoByCartItemId(this.customerNo, this.$route.query.itemId).then((res) => {
        console.log(res, 'ressss')
        let result = res
        this.result = res
        makeSureAsync(that, 'initOrderBasicData', [result]).then(res => {
          makeSureAsync(that, 'fetchSkuList', [result]).then(res => {
            makeSureAsync(that, 'initOrderGroupData', [result]).then(res =>{
              makeSureAsync(that, 'initSampleCategory', [result]).then(res => {
                makeSureAsync(this, 'initOtherParamData', [result])
              })
            })
          })
        })
        this.shoppingCartProductNumber = this.getNumberFromCart()
      })
    } else if(comeFrom === 'order') {
      this.comeForm = true
      this.text = '加入购物车'
      let that = this
      getSolutionInfoByOrderId(this.$route.query.orderId, this.$route.query.euId).then((res) => {
        console.log(res, 'ressss')
        let result = res
        this.result = res
        makeSureAsync(that, 'initOrderBasicData', [result]).then(res => {
          makeSureAsync(that, 'fetchSkuList', [result]).then(res => {
            makeSureAsync(that, 'initOrderGroupData', [result]).then(res =>{
              makeSureAsync(that, 'initSampleCategory', [result]).then(res => {
                makeSureAsync(this, 'initOtherParamData', [result])
              })
            })
          })
        })
        this.shoppingCartProductNumber = this.getNumberFromCart()
      })
    } else {
      this.comeForm = false
      this.text = '加入购物车'
      if (this.$route.query.templateNo) {
        this.currEu = this.$route.query.templateNo
      }
      if (!specialEuTemplateNo().includes(this.currEu)) {
        this.controlGroup.push({'experimental':this.experimentalGroup[0], 'control':this.experimentalGroup[1]})
      }
      this.fetchSkuList()
      this.shoppingCartProductNumber = this.getNumberFromCart()
      this.setUserInputData()
    }
  },
  methods: {
    /**
     * 该方法还原用户上次输入的内容
     */
    setUserInputData () {
      this.pickSampleSpec(undefined, true)
      this.getSampleArrIndex()
      this.onConfirmDiseaseDirection()
      this.handleChangeSampleType(true)
      // this.onConfirmDeliveryTime(undefined, true)
    },
    validateControlGroup () {
      let that = this
      if (this.controlGroup.length > 0) {
        this.controlGroup.forEach(item => {
          if (JSON.stringify(item.control) === '{}' || JSON.stringify(item.experimental) === '{}') {
            this.$weui.dialog({
              title: '生信分析对照组设置错误!',
              content: '请仔细检查生信分析对照组，确保您设置了所有的实验组和对照组！',
              buttons: [
                {
                  label: '返回修改',
                  type: 'primary',
                  onClick: function () {
                    if (that.stepNo === 1) {
                      that.stepNo = that.stepNo - 1
                      that.$forceUpdate()
                    }
                  }
                }
              ],
            })
            this.validateFlag = false
            return false
          } else {
            return this.validateFlag = true
          }
        })
      }
    },
    reSetPageScroll () {
      console.log('ssssssssssssssssssssss')
      this.$nextTick(() => {
        window.scrollTo(0, 0)
        document.body.scrollTo(0, 0)
      });
    },
    specialEuTemplateNo,
    /**
     * 依据只能推荐的参数自动选择样本分类
     * @return indexArr[indexF, indexS] 选择的序号
     */
    getSampleArrIndex () {
      if (localStorage.getItem('sample') !== null && localStorage.getItem('sample') !== undefined) {
        let object = JSON.parse(localStorage.getItem('sample'))
        let indexArr = []
        this.sampleCategoryOptArr.forEach((item, index) => {
          if (item.dictKey === object.currentCategory.dictKey) {
            indexArr.push(index)
          }
        })
        this.sampleSubCategoryOptArr.forEach((item, index) => {
          if (item.dictKey === object.currentSubCategory.dictKey) {
            indexArr.push(index)
          }
        })
        this.pickSampleCategory(indexArr[0])
        this.pickSubCategory(indexArr[1])
        localStorage.removeItem('sample')
      }
    },
    /**
     * 获取购物车数量
     */
    getNumberFromCart () {
      let number = 0
      for (let key in this.cartList.cartContent) {
        if (this.cartList.cartContent[key].productQuantity) {
          number = number + this.cartList.cartContent[key].productQuantity
        } else {
          number = number + 1
        }
      }
      return number
    },
    /**
     * @description 验证疾病方向输入
     */
    validateDiseaseDirection () {
      if (this.diseaseDirectionName === '') {
        this.validateFlag = false
        return false
      } else {
        this.validateFlag = true // 第一个验证的表单元素
        return true
      }
    },
    validateOtherSampleSpecName () {
      if (this.currTaxId === '10117' && this.otherSampleSpecName === '') {
        this.validateFlag = false
        return false
      } else {
        this.validateFlag = true && this.validateFlag
        return true
      }
    },
    /**
     * @description 验证样本分类输入
     */
    validateSampleCategory () {
      if (JSON.stringify(this.sampleCategory) === '{}') {
        this.validateFlag = false
        return false
      } else {
        if (this.showErr) {
          this.validateFlag = false
          this.bizValidateMsg = '注意：' + this.sampleCategory.label + '无法进行' + this.eu1.name + '实验'
          return false
        } else {
          this.validateFlag = true && this.validateFlag
          this.bizValidateMsg = ''
          return true
        }
      }
    },
    /**
     * @description 验证样本类型输入
     */
    validateSampleType () {
      if (this.sampleType === '') {
        this.validateFlag = false
        return false
      } else {
        this.validateFlag = true && this.validateFlag
        return true
      }
    },
    /**
     * @description 验证到达时间
     */
    validateDeliveryTime () {
      if (this.deliveryTime === '') {
        this.validateFlag = false
        return false
      } else {
        this.validateFlag = true && this.validateFlag
        return true
      }
    },
    /**
     * @description 验证物种是否输入
     */
    validateSampleSpec () {
      if (this.sampleSpec === '') {
        this.bizValidateMsg = '请选择物种'
        this.validateFlag = false
        return false
      } else {
        this.validateFlag = true && this.validateFlag
        if (this.validateFlag) {
          this.bizValidateMsg = ''
        }
        return true
      }
    },
    /**
     * @description 验证样本数量
     */
    validateSampleNum () {
      let number = 0

      this.experimentalGroup.forEach( item => {
        number += item.number
      })
      if (number < this.currSku.minSampleQuantity) {
          this.$weui.dialog({
            title: '样本数量超低于实验下限!',
            content: '为了保证实验的有效性，'+ this.eu1.name + '样本数量最低为' + this.currSku.minSampleQuantity + '个',
            buttons: [
                {
                  label: '返回修改',
                type: 'primary',
                }
              ],
          })
        this.validateFlag = false
        return false
      } else if (number > this.currSku.maxSampleQuantity) {
        this.$weui.dialog({
          title: '样本数量超过实验上限!',
          content: '为了保证实验的有效性，' + this.eu1.name + '样本数量最大为' + this.currSku.maxSampleQuantity + '个',
          buttons: [
              {
              label: '返回修改',
              type: 'primary',
            }
          ],
        })
        this.validateFlag = false
        return false
      } else if (number < 3 && this.currEu !== specialEuTemplateNo(0)) {
        this.$weui.dialog({
          title: '样本数量过小!',
          content: '建议重复数大于等于3，否则会造成数据定量准确 性受损，从而影响文章发表',
          buttons: [
            {
              label: '我再想想',
              type: 'default'
            },{
              label: '立即更改',
              type: 'primary',
            }
          ],
        })
        this.validateFlag = false
        return false
      } else if (number < 1 && this.currEu === specialEuTemplateNo(0)) {
        this.$weui.dialog({
          title: '样本数量过小!',
          content: '最少需要一个样本',
          buttons: [
              {
              label: '立即更改',
              type: 'primary',
            }
          ],
        })
        this.validateFlag = false
        return false
      }else {
        this.validateFlag = true
        return true
      }
    },
    /**
     * 下一步操作
     */
    nextStep() {
      if ( this.stepNo === 0) {
        new Promise(resolve => {
          this.validateControlGroup()
          this.$refs.diseaseDirectionField.focus()
          this.$refs.diseaseDirectionField.blur()
          this.$refs.sampleCategoryField.focus()
          this.$refs.sampleCategoryField.blur()
          this.$refs.sampleTypeField.focus()
          this.$refs.sampleTypeField.blur()
          Toast.loading();
          setTimeout(() => {
            Toast.clear();
            resolve(this.validateFlag)
          }, 200)
        }).then(formValidate => {
          new Promise( resolve => {
              if (formValidate){
                resolve(this.validateSampleNum()&&this.validateSampleSpec())
              } else {
                resolve(false)
              }
          }).then( bizValidate =>{
            if(bizValidate){
              if (this.stepNo < 2) {
                if (specialEuTemplateNo(0).includes(this.currEu)) {
                  this.stepNo = this.stepNo + 2;
                  this.showProcessTech = [false, false, false]
                } else {
                  this.stepNo = this.stepNo + 1;
                }
              }
            }
          })
        })
      } else {
        this.stepNo = this.stepNo + 1;
      }
    },
    /**
     * 返回按钮操作
     */
    goBack() {
      if (this.stepNo > 0) {
        if (specialEuTemplateNo().includes(this.currEu)) {
          this.stepNo = this.stepNo - 2;
        } else {
          this.stepNo = this.stepNo - 1;
        }
      } else {
        if (this.comeFrom) {
          wx.miniProgram.switchTab({
            url: "/pages/cart/cart",
          })
        } else {
          this.$router.back()
        }
      }
    },
    /**
     * 初始化选择按钮
     */
    initRadioTag() {
      // 初始化样本物种选项的选择状态
      for (let i = 0; i < 4; i++) {
        this.$set(this.sampleSpecItemChecked, i, false);
      }
      // 初始化样本类型选项的选择状态
      for (let i = 0; i < this.sampleCategoryOptArr.length; i++) {
        this.$set(this.sampleCategoryItemChecked, i, false);
      }
      // 初始化样本子类型选项的选择状态
      for (let i = 0; i < this.sampleSubCategoryOptArr.length; i++) {
        this.$set(this.subCategoryChecked, i, false);
      }
    },
    /**
     * 获取SKU列表
     */
    fetchSkuList () {
      console.log('数据已还原', this.currEu)
      console.log('vvvvvvvvvvvvvvvvvvvvvvvv')
      this.$weui.loading('加载中')
      let that = this
      let returnValue
      this.gcapi('getProteomicsBasicData', '').then(res => {
        if (res.data.code === 0) {
          that.euTemplates = JSON.parse(res.data.result.euTemplates)
          that.eus = []
          console.log(that.currEu, this.currEu, 'sidjuo')
          this.currEu = this.currEu ? this.currEu : that.$route.query.templateNo
          that.puTemplates = JSON.parse(res.data.result.puTemplates)
          that.proteomicsSku = res.data.result.proteomicsSku.sort(function (a, b) {
            return  a.sortOrder - b.sortOrder
          })
          that.specPuTemplates = JSON.parse(res.data.result.specPuTemplates)
          let sku
            sku = that.proteomicsSku
                .filter( v => v.eu1 === this.currEu)
                .filter( v => v.valid === 1)
                .filter( v => v.sampleCategory === -1)
                .filter( v => v.paraReturnMaterial === this.returnMaterialChecked ? 1 : 0)[0]
          console.log(sku, 'su', that.proteomicsSku, this.returnMaterialChecked ? 1 : 0)
            this.currSku = sku
            console.log('Default Sku:',that.currSku)
            if (this.currEu === paraffinEuTemplateNo()) {
              this.pickSampleCategory(0)
              this.pickSubCategory(0)
            }
          returnValue = that.getBoSolutionBasicInfo()
        }
        this.$weui.loading('加载中').hide()
      })
      return returnValue
    },
    /**
     * 样本物种选择
     * @param index
     */
    pickSampleSpec(index, enable) {
      if (localStorage.getItem('sampleSpec') && enable) {
        index = parseInt(localStorage.getItem('sampleSpec'))
      }
      localStorage.removeItem('sampleSpec')
      if (index !== null && index !== undefined) {
        localStorage.setItem('sampleSpec', index)
        for (let i = 0; i < 4; i++) {
          if (i === index) {
            this.sampleSpecItemChecked[index] =
                !this.sampleSpecItemChecked[index];
            if (this.sampleSpec === this.sampleSpecOptArr[index].chnName) {
              this.sampleSpec = ''
              this.eu1.taxId = ''
            } else {
              this.sampleSpec = this.sampleSpecOptArr[index].chnName;
              let taxMap = Emkt.getEmktMetaData().dictionariesMap[61033];
              for (const key in taxMap) {
                if (taxMap[key].dictValue === this.sampleSpecOptArr[index].engName) {
                  this.currTaxId = key
                  this.eu1.taxId = this.currTaxId
                  this.boSolution.children[0].taxId = this.currTaxId
                  break
                }
              }
            }
            this.bizValidateMsg = ''
          } else {
            this.$set(this.sampleSpecItemChecked, i, false)
          }
        }
        console.log(index === 3)
        console.log('执行4')
        this.showOtherSampleSpecInput = index === 3
        if (this.showOtherSampleSpecInput) {
          this.handleOtherSpecNameChanged()
        }
        console.log(this.showOtherSampleSpecInput)
        this.databaseBuildingInit()
        this.getPreferPrice()
        this.$forceUpdate()
      }
    },
    /**
     * 样本其他物种的输入
     * @param index
     */
    handleOtherSpecNameChanged() {
      if (localStorage.getItem('otherSpecName')) {
        this.otherSampleSpecName = localStorage.getItem('otherSpecName')
      }
      localStorage.setItem('otherSpecName', this.otherSampleSpecName)
      if( this.eu1.taxId === '10117') {
        this.eu1.otherTaxName = this.otherSampleSpecName
        this.boSolution.children[0].otherTaxName = this.otherSampleSpecName
        this.getPreferPrice()
      }
    },
    /**
     * 显示样本分类选择弹框
     */
    showSampleCategoryPopup() {
      this.showSampleCategory = true
    },
    /**
     * 关闭样本分类选择弹框
     */
    closeSampleCategoryPopup() {
      this.showSampleCategory = false
      this.$refs.sampleCategoryField.focus()
      this.$refs.sampleCategoryField.blur()
      this.validateSampleCategory()
    },
    /**
     * 样本分类选择
     * @param index
     */
    pickSampleCategory(index) {
      for (let i = 0; i < this.sampleCategoryOptArr.length; i++) {
        if (i === index) {
          this.sampleCategoryItemChecked[index] =
            !this.sampleCategoryItemChecked[index];
          this.currSampleCategory = this.sampleCategoryOptArr[index].dictValue;
          this.databaseBuildingInit()
        } else {
          this.$set(this.sampleCategoryItemChecked, i, false);
        }
      }
    },
    /**
     * 选择子类型
     * @param index
     */
    pickSubCategory(index) {
      for (let i = 0; i < this.sampleSubCategoryOptArr.length; i++) {
        if (i === index) {
          this.subCategoryChecked[index] = !this.subCategoryChecked[index];
          let object = {};
          object.loSampleTypeId = this.sampleSubCategoryOptArr[index].loSampleTypeId
          object.label = this.sampleSubCategoryOptArr[index].dictValue;
          object.currSampleCategory = this.currSampleCategory;
          object.currSampleSubCategory = this.sampleSubCategoryOptArr[index];
          if (object.currSampleSubCategory.dictValue.search('穿刺') !== -1 || object.currSampleSubCategory.dictValue.search('<') !== -1){
            if (this.currEu === 'EU000302') { //如果是 4D label free
              this.currEu ='EU000333' // 变成超微量4D label free
            }
            if (this.currEu === 'EU000331') { //如果是DIA2.0
              this.currEu = 'EU000334' // 变成超微量DIA2.0
            }
          } else {
            if (this.currEu === 'EU000333') { //如果是超微量4D label free
              this.currEu = 'EU000302' // 变成4D label free
            }
            if (this.currEu === 'EU000334') { //如果是超微量DIA2.0
              this.currEu = 'EU000331' // 变成DIA2.0
            }
          }
          this.sampleCategory = object;
        } else {
          this.$set(this.subCategoryChecked, i, false);
        }
      }
        this.constructBoSolution('BASIC')
        this.getPreferPrice()
    },
    /**
     * 禁用建库技术, 可禁用DIA6
     */
    handleDatabaseBuildingChecked(index) {
      if (this.showProcessTech[1]) {
        this.showProcessTech[1].default = null
      }
      this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[index]
      this.constructBoSolution('ADVANCE')
      this.getPreferPrice()
    },
    databaseBuildingInit() {
      // 当样本分类选择为「组织样本」
      if(this.currSampleCategory === this.sampleCategoryOptArr[0].dictValue) {
        if (this.currTaxId === '9606') {
          this.constructionTechEnable[0] = true // 物种=人 可选
        }else {
          this.constructionTechEnable[0] = false // 其他物种不可选
        }
        this.constructionTechEnable[1] = false // 6级不可选
        this.constructionTechEnable[2] = true // 12级可选
        // this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[2]
      }

      // 当样本分类选择为「细胞样本」
      if(this.currSampleCategory === this.sampleCategoryOptArr[1].dictValue) {
        if (this.currTaxId === '9606') {
          this.constructionTechEnable[0] = true // 物种=人 可选
        } else {
          this.constructionTechEnable[0] = false // 其他物种不可选
        }
        this.constructionTechEnable[1] = false // 6级不可选
        this.constructionTechEnable[2] = true // 12级可选
        // this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[2]
      }

      // 当样本分类选择为「体液样本」大类
      if (this.currSampleCategory === this.sampleCategoryOptArr[2].dictValue) {
        this.constructionTechEnable[0] = false // 无需建库不可选
        this.constructionTechEnable[1] = true // 6级可选
        this.constructionTechEnable[2] = false // 12级不可选
        // this.databaseBuildings = this.sampleProcessTech.ParaConstructionTech[1]
      }
    },
    /**
     * 增加实验组
     */
    addExperimental(name, number) {
      this.experimentalGroup.push({
        label: name ? name : "实验组名称" + (this.experimentalGroup.length + 1),
        number: number ? number : 3,
      });
      this.updateGroupsAndParameters()
      this.getPreferPrice()
    },
    /**
     * 删除实验组
     * @param index 要删除的索引值
     */
    removeExperimental(index) {
      let minLength = this.productInfo.eu1 === specialEuTemplateNo(0) ? 1 : 2
      if (this.experimentalGroup.length <= minLength) {
        Toast(this.eu1.name + '最少需要' + minLength + '个分组')
      } else {
        this.experimentalGroup.splice(index, 1);
        this.updateGroupsAndParameters()
        this.getPreferPrice()
      }
    },
    /**
     * 修改实验组名称
     */
    handleChangeGroupName (index) {
      this.groups[index].name = this.experimentalGroup[index].label
      this.updateGroupsAndParameters()
      this.getPreferPrice()
    },
    /**
     * 修改实验组数量
     */
    handleChangeGroupNum (index, mini) {
      console.log(this.experimentalGroup[index].number, 'ssssssssss')
      if (this.experimentalGroup[index].number && this.experimentalGroup[index].number !== '') {
        this.groups[index].bioRepeatTimes = this.experimentalGroup[index].number
        this.updateGroupsAndParameters()
        this.getPreferPrice()
      }
    },
    overLimit (number) {
      if (number !== 0) {
        Toast(this.eu1.name + '每组至少需要'+ number +'个样本')
      }
    },
    /**
     * 删除指定index基因
     * @param index
     */
    removeGeneSearchResult(index) {
      this.geneSelectionGroup.splice(index, 1);
    },
    /**
     * 确认日期选择
     */
    onConfirmDeliveryTime(date,enable) {
      if (enable && localStorage.getItem('date')) {
        date = new Date(parseInt(localStorage.getItem('date')))
      }
      if (date) {
        localStorage.setItem('date', date.getTime())
        this.deliveryTime = `${date.getFullYear()}-${
            date.getMonth() + 1
        }-${date.getDate()}`;
        this.showCal = false;
      }
    },
    /**
     * 确认疾病方向选择
     */
    onConfirmDiseaseDirection(value) {
      console.log(localStorage.getItem('diseaseDirection'), localStorage.getItem('diseaseDirection') !== 'undefined' && localStorage.getItem('diseaseDirection') !== 'null')
      if (localStorage.getItem('diseaseDirection') !== 'undefined' && localStorage.getItem('diseaseDirection') !== 'null'){
        value = JSON.parse(localStorage.getItem('diseaseDirection'))
      }
      localStorage.setItem('diseaseDirection', JSON.stringify(value))
      if (value) {
        this.diseaseDirectionId = value.diseaseKey;
        this.diseaseDirectionName = value.diseaseName;
        this.showDiseaseDirectionPicker = false;
      }
    },
    /**
     * 取消疾病方向选择
     */
    onCancelDiseaseDirection(value) {
      this.$refs.diseaseDirectionField.focus()
      this.$refs.diseaseDirectionField.blur()
      this.showDiseaseDirectionPicker = false;
    },
    /**
     *增加生信分析对照组
     */
    addControlGroup() {
      let object = {};
      object.experimental = {};
      object.control = {};
      this.controlGroup.push(object);
      // 增加无需重新计算，选择对照组第二个下拉列表再计算
    },
    /**
     * 需要移除的对照组
     * @param index
     */
    removeControlGroup(index) {
      if (this.controlGroup.length <= 1) {
        Toast(this.eu1.name + '至少需要一组生信分析对照组')
      } else {
        this.controlGroup.splice(index, 1)
        this.constructEuParameterValues()
        this.updateGroupsAndParameters()
        this.getPreferPrice()
      }
    },
    /**
     * @description 选择对照组触发
     */
    handleChangeExperimentalControl() {
      this.constructEuParameterValues()
      this.updateGroupsAndParameters()
      this.getPreferPrice()
    },
    /**
     * @description 将数据保存到购物车中，这个数据也用于再次购买和分享购物车
     * @author AnyaParry
     */
    ...mapMutations([
      'ADD_CART_LIST', 'UPDATE_CART_CONTENT'
    ]),
    gotoCart () {
      let cartData = {}
      cartData['categoryId'] = 99
      const itemId = this.$route.query.itemId
      cartData['itemId'] = itemId ? itemId : new Date().getTime()
      cartData['workdays'] = this.serviceWorkDaysSolution.workdays
      cartData['promotions'] = [this.promotion]
      cartData['diseaseDirectionName'] = this.diseaseDirectionName
      cartData['diseaseDirectionId'] = this.diseaseDirectionId
      cartData['boSignalAnalysis'] = this.boSignalAnalysis.dictValue
      cartData['databaseBuildings'] = this.databaseBuildings.dictValue
      cartData['sampleProcessing'] = this.sampleProcessing.dictValue
      cartData['icon'] = 'service.png'
      cartData['product'] = this.eu1.name
      cartData['userLabel'] = (this.sampleSpec ? this.sampleSpec + '/' : '') +
        (this.sampleType ? this.sampleType + '/' : '') +
        (this.experimentalTotalNum ? this.experimentalTotalNum + '个样本' : '')
      cartData['allData'] = {
        'otherSampleSpecName': this.otherSampleSpecName,
        'returnMaterialChecked': this.returnMaterialChecked,
        'deliveryTime': this.deliveryTime,
        'sampleType': this.sampleType.trim(),
        'loSampleTypeId': this.sampleCategory.loSampleTypeId, // 样本类型Id(与labonline对应)
        'boSolution': Object.assign({}, this.boSolution),
        'currSkuId': this.currSku.id,
        'diseaseDirectionId': this.diseaseDirectionId,
        'diseaseDirectionName': this.diseaseDirectionName,
        'geneSelectionGroup': this.geneSelectionGroup,
        'experimentalGroup': this.experimentalGroup,
        'experimentalTotalNum': this.experimentalTotalNum,
        'controlGroup': this.controlGroup,
      }

      if (itemId) {
        this.oldCartContent[itemId] = cartData
        this.UPDATE_CART_CONTENT(JSON.stringify(this.oldCartContent))
        this.$weui.toast('商品更新成功！', 3000)
      } else {
        localStorage.setItem('saveToCart', true)
        this.ADD_CART_LIST(cartData)
      }
      this.shoppingCartProductNumber = Object.keys(this.cartList.cartContent).length
      localStorage.removeItem('sampleSpec')
      localStorage.removeItem('sampleType')
      localStorage.removeItem('diseaseDirection')
      localStorage.removeItem('date')
      this.$forceUpdate()
    },
    getMeteData() {
      let dictionary = Emkt.getEmktMetaData().dictionariesMap;
      for (const key in dictionary[100026]) {
        let opt = {}
        opt.diseaseKey = key
        opt.diseaseName = dictionary[100026][key].dictValue
        this.diseaseDirectionOpts.push(opt);
      }
      for (const key1 in dictionary[71003]) {
        this.sampleProcessTech.ParaReturnMaterial.push(dictionary[71003][key1].dictValue);
      }
      for (const key5 in dictionary[71007]) {
        this.sampleCategoryOptArr.push(dictionary[71007][key5]);
      }
      for (const key6 in dictionary[71008]) {
        let obj = dictionary[71008][key6]
        let extraValue = dictionary[71008][key6].extraValue
        // 解析 parentId 和 loSampleTypeId
        // extraValue eg: {"parentId":1, loSampleTypeId:10}
        if (extraValue) {
          let extraValueMap = JSON.parse(extraValue)
          obj.parentId = extraValueMap.parentId
          obj.loSampleTypeId = extraValueMap.loSampleTypeId
        }
        this.sampleSubCategoryOptArr.push(obj)
      }

      console.log(dictionary[61033])
      console.log(dictionary[100026])
      console.log(dictionary[71002])
      console.log(dictionary[71003])
      console.log(dictionary[71004])
      console.log(dictionary[71005])
      console.log(dictionary[71006])
      console.log(dictionary[71007])
      console.log(dictionary[71008])
    },
    handleChangeSampleType (enable) {
      if (localStorage.getItem('sampleType') && enable) {
        this.sampleType = localStorage.getItem('sampleType')
      }
      localStorage.setItem('sampleType', this.sampleType)
      this.getPreferPrice()
    },
    /**
     * @description  是否返回状态改变触发
     */
    handleChangeReturnMaterial () {
      this.returnMaterialChecked = !this.returnMaterialChecked
      // 剩余样本返还 无需添加实物返还EU
      // this.constructBoSolution('BASIC')
      // console.log(this.boSolution, 'vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv------------')
      // this.getPreferPrice()
    },
    /**
     * @description 样本处理选项选择后的逻辑
     */
    handleSampleProcessChecked (index) {
      if (this.showProcessTech[0]) {
        this.showProcessTech[0].default = null
      }
      this.sampleProcessing = this.sampleProcessTech.ParaRemoveHAProtein[index]
      this.constructBoSolution('ADVANCE')
      this.getPreferPrice()
    },
    /**
     * @description 生信分析参数选择后的逻辑
     */
    handleBoSignalAnalysisChecked (index) {
      if (this.showProcessTech[2]) {
        this.showProcessTech[2].default = null
      }
      this.boSignalAnalysis = this.sampleProcessTech.ParaBioAnalysis[index]
      this.constructBoSolution('ADVANCE')
      this.getPreferPrice()
    },
    /**
     * @description 处理基因选择
     */
    handleChangeGene () {
      this.updateGroupsAndParameters ()
      this.getPreferPrice()
    },
    /**
     * @description 获取服务类商品的预计交付周期以及质量承诺与服务说明和計算价格所需参数
     * @param euNo
     */
    getBoSolutionBasicInfo () {
      let r = null
      this.constructBoSolution('BASIC')
      let that = this
      this.gcapi('loGetBoSolutionBasicInfo', JSON.stringify(this.boSolution)).then(function (response) {
        if (response.body.code === 0) {
          that.serviceWorkDaysSolution = JSON.parse(response.body.result)
          that.boSolution.children = that.serviceWorkDaysSolution.bExperimentUnitList
          // console.log('get BoSolution basic info done', JSON.parse(response.body.result))
          that.constructGroups()
          that.constructEuParameterValues()
          that.getBasicPrice()
        } else {
          // $.showPreloader('保存失败！')
        }
        r = true
      })
      return r
    },
    /**
     * @description 获取服务类产品的最优价格
     * @param euNo
     */
    getPreferPrice () {
      let that = this
      this.gcapi('loGetBoSolutionBasicInfo', JSON.stringify(this.boSolution)).then(function (response) {
        if (response.body.code === 0) {
          that.serviceWorkDaysSolution = JSON.parse(response.body.result)
          that.boSolution.children = that.serviceWorkDaysSolution.bExperimentUnitList
          // console.log('get BoSolution basic info done', response.body.result)
          that.constructGroups()
          that.constructEuParameterValues()
          let req = {}
          that.boSolution.id = -100
          req.solutionJsons = [JSON.stringify(that.boSolution)]
          that.gcapi('getServiceProductPreferPrice', req).then(function (response) {
            if (response.body.code === 0) {
              that.priceSolution = response.body.result
              let solutionJson = JSON.parse(response.body.result.solutionJsons[0])
              that.formalQuotePrice = solutionJson.formalQuotePrice
              that.standardPrice = solutionJson.standardPrice
            } else {
              // $.showPreloader('保存失败！')
            }
          })
        } else {
          // $.showPreloader('保存失败！')
        }
      })
    },
    /**
     * @description 获取服务类产品的最优价格
     * @param euNo
     */
    getBasicPrice () {
      let req = {}
      req.solutionJsons = [JSON.stringify(this.boSolution)]
      let that = this
      this.gcapi('getServiceProductPreferPrice', req).then(function (response) {
        if (response.body.code === 0) {
          that.priceSolution = response.body.result
          let solutionJson = JSON.parse(response.body.result.solutionJsons[0])
          that.formalQuotePrice = solutionJson.formalQuotePrice
          that.standardPrice = solutionJson.standardPrice
          console.log('get prefer price done--------------------', response.body.result)
        } else {
          // $.showPreloader('保存失败！')
        }
      })
    },
    /**
     * 获取方案详情
     */
    getSolutionDetail (solutionId) {
      let that = this
      this.gcapi('loLoadSolutionDetail', solutionId).then(res => {
        if (res.body.code === 0) {
          that.boSolution = res.body.result
        }
      })
    },
    /**
     * @description 构造解决方案
     */
    constructBoSolution (type) {
      if( type === 'BASIC') {
        console.log(type)
        this.querySkuBasic()
        let that = this
      } else {
        this.querySkuAdvance()
      }
      console.log(this.currSku , 'currSku')
      this.createEu(this.currSku.eu1)
      this.createEu(this.currSku.eu2)
      this.constructEus()
      this.constructEuSubLines()
      this.boSolution.id = -100
      this.boSolution.sortOrderManualModified = false
      console.log('--------------------------------------------------------------------------=>>>>>>>>>>>>>>>>>>>>>>>')
      this.getPreferPrice()
    },
    /**
     * @description  创建 eu 数据
     * @param EU编号
     */
    createEu (euNo) {
      console.log('Starting create Experimental Unit, euNo:', euNo)
      if (euNo === '' || euNo === undefined) {
        // this.eu2 = undefined
        return
      }
      let euTemplate = this.euTemplates.filter(v => v.templateNo === euNo)[0]
      let eu = {}
      eu.id = -1
      eu.taxId = this.currTaxId
      if( eu.taxId === '10117') {
        eu.otherTaxName = this.otherSampleSpecName
      }
      eu.stageNo = 1
      eu.sortOrder = 1
      eu.name = euTemplate.externalName
      let template = {}
      template.id = euTemplate.id
      template.productGuid = euTemplate.productGuid
      eu.template = template
      if (euNo === RETURN_MATERIAL_EU_NO) {
        this.eu2 = eu
        this.eu2.id = -2
        this.eu2.sortOrder = 2
      } else {
        this.eu1 = eu
        this.eu2 = {}
      }
      console.log('Build Experimental Unit done:', eu)
    },
    /**
     * @description 构造 EU数据
     */
    constructEus () {
      this.eus = []
      console.log(this.eu2, 'eu2,,,,,,,,,,,,,,,')
      if (JSON.stringify(this.eu1) !== '{}') {
        this.eus.push(this.eu1)
      }
      if (JSON.stringify(this.eu2) !== '{}') {
        this.eus.push(this.eu2)
      }
      this.boSolution.children = this.eus
      this.constructPus()
    },
    /**
     * @description  创建 pu 数据
     * @param PU编号
     */
    createPu (puNo) {
      console.log('Starting create Price Unit, puNo:', puNo)
      if (puNo === '' || puNo === undefined) {
        return
      }
      if (puNo.indexOf('SPEC') !== -1) {
        this.createSpecPu()
        return
      }
      let puTemplate = this.puTemplates.filter(v => v.templateNo === puNo)[0]
      if (puTemplate === undefined) {
        console.log('Ops!  The puNo has not found', puNo)
        return
      }
      let pu = {}

      pu.id = this.puIdInit
      this.puIdInit -= 1
      pu.workdays = puTemplate.workdays
      let template = {}
      template.workdays = puTemplate.workdays
      template.id = puTemplate.id
      template.nodeId = parseInt(this.puIdInit) // 服务端没有要求，先填随机数
      this.puIdInit -= 1
      template.type = puTemplate.type
      template.templateNo = puNo
      pu.template = template
      pu.sortOrder = 1

      if (puNo === 'PU000914') {
        this.pus2.push(pu)
      } else {
        this.pus1.push(pu)
      }
      console.log('Build Price Unit done:', pu)
    },
    /**
     * @description  创建 specpu ,仅适用于TMT蛋白组学和磷酸化TMT蛋白组学
     * @param PU编号
     */
    createSpecPu () {
      console.log('Starting create spec Price Unit')
      console.log('current EU is: ', this.currEu)
      if ('EU000040' !== this.currEu && 'EU000039' !== this.currEu) {
        return
      }

      let n = this.experimentalTotalNum
      let spec1 = this.specPuTemplates.SPEC1
      let spec2 = this.specPuTemplates.SPEC2

      let specPuTemplate = {}
      if( 'EU000039' === this.currEu){
        for (let i = 0; i < spec1.length; i++) {
          if (spec1[i].limitExpression === undefined) {
            specPuTemplate = this.specPuTemplates.SPEC1[i]
          }
          if (eval(spec1[i].limitExpression)) {
            console.log('spec1 limitExpression',spec1[i].limitExpression)
            specPuTemplate = this.specPuTemplates.SPEC1[i]
          }
        }
      }
      if ('EU000040' === this.currEu){
        for (let i = 0; i < spec2.length; i++) {
          if (spec2[i].limitExpression === undefined) {
            specPuTemplate = this.specPuTemplates.SPEC2[i]
          }
          if (eval(spec2[i].limitExpression)) {
            console.log('spec2 limitExpression',spec2[i].limitExpression)
            specPuTemplate = this.specPuTemplates.SPEC2[i]
          }
        }
      }

      if (specPuTemplate === undefined) {
        console.log('Ops!  The spec puNo has not found', puNo)
        return
      }
      let pu = {}
      pu.id = this.puIdInit
      this.puIdInit -= 1
      pu.workdays = specPuTemplate.workdays
      let template = {}
      template.workdays = specPuTemplate.workdays
      template.id = specPuTemplate.id
      template.nodeId = this.puIdInit
      this.puIdInit -= 1 // 服务端没有要求，先填随机数
      template.type = specPuTemplate.type
      template.templateNo = specPuTemplate.templateNo
      pu.template = template
      pu.sortOrder = 1
      this.pus1.push(pu)
      console.log('Build spec price unit done:', pu)
    },
    /**
     * @description 构造PU数据
     */
    constructPus () {
      this.pus1 = []
      this.pus2 = []

      for (let i = 0; i < this.currSku.eu1_Pus.length; i++) {
        this.createPu(this.currSku.eu1_Pus[i])
      }
      for (let i = 0; i < this.currSku.eu2_Pus.length; i++) {
        this.createPu(this.currSku.eu2_Pus[i])
      }

      this.boSolution.children[0].children = this.pus1
      if (this.boSolution.children[1] !== undefined){
        this.boSolution.children[1].children = this.pus2
      }
      this.constructPuSubLines()
    },
    /**
     * @description 构造PU拓扑结构
     */
    constructPuSubLines () {
      let subLines = []
      for (let i = 0; i < this.pus1.length; i++) {
        if (i < this.pus1.length - 1) {
          let subLine = {}
          subLine.northId = this.pus1[i].id
          subLine.southId = this.pus1[i + 1].id
          subLines.push(subLine)
        }
      }
      this.eu1.subLines = subLines
      if( JSON.stringify(this.eu2) !== '{}')
      {
        this.eu2.subLines = []
      }
    },
    /**
     * @description 根据用户选择查询对应SKU
     */
    querySkuBasic () {
      let sku = this.proteomicsSku.filter( v => v.eu1 === this.currEu).filter( v => v.valid === 1)
      if (this.returnMaterialChecked) {
        sku = sku.filter( v => v.paraReturnMaterial === 1)
      } else {
        sku = sku.filter( v => v.paraReturnMaterial === 0)
      }
      console.log(sku, 'ssssss')
      // let tmpSku = []
      if (JSON.stringify(this.sampleCategory) !== '{}') {
        sku = sku.filter( v => v.sampleCategory === this.sampleCategory.currSampleSubCategory.dictKey)
      }
      if ( sku.length > 0) { // 如果没有查到继续用未过滤之前的列表
        this.showErr = false
        this.currSku = sku[0]// 设置样本处理选项是否需要显示。 当该处理方法全部是-1 的时候则不显示该处理方法
        this.showProcessTech = [{show:false, elements:[], default: null},{show:false, elements:[], default: null},{show:false, elements:[], default: null}]
        // 收集所有参数值并利用set特性去除参数的重复值
        let setRemoveHAProtein = new Set()
        let setConstructionTech = new Set()
        let setBioAnalysis = new Set()
        //设定UI的显示为默认选中值sku[0]
          if (sku[0].paraRemoveHAProtein && !this.comeForm) {
            console.log(sku[0])
            this.showProcessTech[0].default = sku[0].paraRemoveHAProtein
          }
          if (sku[0].paraConstructionTech && !this.comeForm) {
            this.showProcessTech[1].default = sku[0].paraConstructionTech
          }
          if (sku[0].paraBioAnalysis && !this.comeForm) {
            this.showProcessTech[2].default = sku[0].paraBioAnalysis
          }
        for(let i=0; i<sku.length; i++) {
          if (sku[i].paraRemoveHAProtein !== -1){
            setRemoveHAProtein.add(sku[i].paraRemoveHAProtein)
            this.showProcessTech[0].show = true
          }
          if (sku[i].paraConstructionTech !== -1){
            setConstructionTech.add(sku[i].paraConstructionTech)
            this.showProcessTech[1].show = true
          }
          if (sku[i].paraBioAnalysis !== -1){
            setBioAnalysis.add(sku[i].paraBioAnalysis)
            this.showProcessTech[2].show = true
          }
        }
        //将set集合值放入数组中
        setRemoveHAProtein.forEach(item => {
          this.showProcessTech[0].elements.push(item)
        })
        setConstructionTech.forEach(item => {
          this.showProcessTech[1].elements.push(item)
        })
        setBioAnalysis.forEach(item => {
          this.showProcessTech[2].elements.push(item)
        })
        // todo Use sortOrder
        this.showProcessTech[0].elements.sort()
        this.showProcessTech[1].elements.sort()
        this.showProcessTech[2].elements.sort()
        this.filterMeteData()
        if (this.comeForm) {
          this.querySkuAdvance()
        }
      } else {
        if (this.eu1.name) {
          this.showErr = true
        }
        this.validateSampleCategory()
      }
    },
    /**
     * 根据sku过滤元数据中不应该存在的数据。
     */
    filterMeteData () {
      let dictionary = Emkt.getEmktMetaData().dictionariesMap;
      this.sampleProcessTech.ParaRemoveHAProtein = []
      this.sampleProcessTech.ParaConstructionTech = []
      this.sampleProcessTech.ParaBioAnalysis = []
      for (const key2 in dictionary[71004]) {
        this.showProcessTech[0].elements.forEach(item => {
          if (item === dictionary[71004][key2].dictKey) {
            console.log(this.showProcessTech[0].default, dictionary[71004][key2].dictKey, 'ijo9999999999999999999999999')
            if (this.showProcessTech[0].default === dictionary[71004][key2].dictKey) {
              this.sampleProcessing = dictionary[71004][key2]
            }
            this.sampleProcessTech.ParaRemoveHAProtein.push(dictionary[71004][key2]);
          }
        })
      }
      for (const key3 in dictionary[71005]) {
        this.showProcessTech[1].elements.forEach(item => {
          if (item === dictionary[71005][key3].dictKey) {
            if (this.showProcessTech[1].default === dictionary[71005][key3].dictKey) {
              this.databaseBuildings = dictionary[71005][key3]
            }
            this.sampleProcessTech.ParaConstructionTech.push(dictionary[71005][key3]);
          }
        })
      }
      for (const key4 in dictionary[71006]) {
        this.showProcessTech[2].elements.forEach(item => {
          if (item === dictionary[71006][key4].dictKey) {
            if (this.showProcessTech[2].default === dictionary[71006][key4].dictKey) {
              this.boSignalAnalysis = dictionary[71006][key4]
            }
            this.sampleProcessTech.ParaBioAnalysis.push(dictionary[71006][key4]);
          }
        })
      }
      console.log(dictionary[71004],dictionary[71005],dictionary[71006], 'ss')
    },
    /**
     * @description 根据用户选择查询对应SKU
     */
    querySkuAdvance () {
      let sku = this.proteomicsSku.filter( v => v.eu1 === this.currEu).filter( v => v.valid === 1)
      if (this.returnMaterialChecked) {
        sku = sku.filter( v => v.paraReturnMaterial === 1)
      } else {
        sku = sku.filter( v => v.paraReturnMaterial === 0)
      }
      if (JSON.stringify(this.sampleCategory) !== '{}') {
        let tmpSku = []
        tmpSku = sku.filter( v => v.sampleCategory === this.sampleCategory.currSampleSubCategory.dictKey)
        if ( tmpSku.length !== 0) { // 如果没有查到继续用未过滤之前的列表
          sku = tmpSku
        }
      }
      if (JSON.stringify(this.boSignalAnalysis) !== '{}') {
        let tmpSku = []
        tmpSku = sku.filter( v => v.paraBioAnalysis === this.boSignalAnalysis.dictKey)
        if ( tmpSku.length !== 0) { // 如果没有查到继续用未过滤之前的列表
          sku = tmpSku
        }
      }

      if (JSON.stringify(this.databaseBuildings) !== '{}') {
        let tmpSku = []
        tmpSku = sku.filter( v => v.paraConstructionTech === this.databaseBuildings.dictKey)
        if ( tmpSku.length !== 0) { // 如果没有查到继续用未过滤之前的列表
          sku = tmpSku
        }

      }
      if (JSON.stringify(this.sampleProcessing) !== '{}') {
        let tmpSku = []
        tmpSku = sku.filter( v => v.paraRemoveHAProtein === this.sampleProcessing.dictKey)
        if ( tmpSku.length !== 0) { // 如果没有查到继续用未过滤之前的列表
          sku = tmpSku
        }
      }
      if (sku.length > 0) {
        this.currSku = sku[0]
      }
    },
    /**
     * @description 构造EU拓扑结构
     */
    constructEuSubLines () {
      let subLines = []
      if (this.eus.length > 1 && this.eus[0].id !== undefined && this.eus[1].id !== undefined) {
        let subLine = {}
        subLine.northId = this.eus[0].id
        subLine.southId = this.eus[1].id
        subLines.push(subLine)
      }
      this.boSolution.subLines = subLines
    },
    /**
     * @description 创建实验组数据
     */
    createGroups () {
      for (let i = 0; i < this.experimentalGroup.length; i++) {
        let group = {}
        group.name = this.experimentalGroup[i].label
        group.techRepeatTimes = 1
        group.bioRepeatTimes = this.experimentalGroup[i].number
        group.groupType = true
        group.parameterValues = []
        group.steps = []
        //样本类型参数
        let parameterValue = {}
        if(this.sampleCategory.currSampleSubCategory !== undefined) {
          parameterValue.value = this.sampleCategory.currSampleSubCategory.dictValue +':'+this.sampleType
        } else {
          parameterValue.value = '-:'+this.sampleType
        }
        parameterValue.duplicateDataType = 2
        if (this.boSolution.children.length !== 0 && this.boSolution.children[0].parameters !== undefined && this.boSolution.children[0].parameters.length !== 0){
          parameterValue.value = this.sampleCategory.label
          parameterValue.duplicateDataType = this.boSolution.children[0].parameters[0].dataType
          parameterValue.parameterId = this.boSolution.children[0].parameters[0].id
          parameterValue.relationId = this.boSolution.children[0].parameters[0].relationId
          parameterValue.dataType = this.boSolution.children[0].parameters[0].dataType
          parameterValue.name = this.boSolution.children[0].parameters[0].name
        }
        group.parameterValues.push(parameterValue)

        // 基因参数
        if (this.currEu === 'EU000046') {
          let parameterValueGen = {}
          let values = []
          for ( let j = 0; j < this.geneSelectionGroup.length; j++) {
            let value ={}
            value.providedType = null
            value.nativeId = this.geneSelectionGroup[j].geneGUID
            value.outlineInfo = this.geneSelectionGroup[j].label
            value.paramDesc = ''
            values.push(value)
          }
          parameterValueGen.values = values
          parameterValueGen.duplicateDataType = 2
          if (this.boSolution.children.length !== 0 && this.boSolution.children[0].parameters !== undefined && this.boSolution.children[0].parameters.length !== 0){
            parameterValueGen.parameterId = this.boSolution.children[0].parameters[1].id
            parameterValueGen.relationId = this.boSolution.children[0].parameters[1].relationId
            parameterValueGen.dataType = this.boSolution.children[0].parameters[1].dataType
            parameterValueGen.name = this.boSolution.children[0].parameters[1].name
            parameterValueGen.duplicateDataType = this.boSolution.children[0].parameters[1].dataType
          }

          if (JSON.stringify(parameterValueGen) !== '{}') {
            group.parameterValues.push(parameterValueGen)
          }
        }
        this.groups.push(group)
      }
    },
    /**
     * @description 构造实验组
     */
    constructGroups () {
      this.groups = []
      this.createGroups()
      this.boSolution.children[0].groups = this.groups
      if (this.boSolution.children[1] !== undefined) {
        // EU2 groups 不需要 parameterValues
        let groupsClone = JSON.parse(JSON.stringify(this.groups))
        for (let i = 0; i< groupsClone.length; i++) {
          groupsClone[i].parameterValues = []
        }
        this.boSolution.children[1].groups = groupsClone
      }
    },
    /**
     * @description 补充解决方案信息
     */
    updateGroupsAndParameters () {
      this.constructGroups()
      this.constructEuParameterValues()
    },
    /**
     * @description 构造对照组信息
     */
    constructEuParameterValues() {
        let firstValue = ''
        for (let j = 0; j < this.controlGroup.length; j++) {
          firstValue += this.controlGroup[j].experimental.label + ' VS ' + this.controlGroup[j].control.label
          if ( j < this.controlGroup.length - 1) {
            firstValue += '\n'
          }
        }

        let paramVal1 = {}
        paramVal1.value = firstValue // Index[0] 为 组名1 VS 组名2， 以\n 分割
        if (this.boSolution.children[0].euParameters !== undefined && this.boSolution.children[0].euParameters.length > 0) {
          paramVal1.parameterId = this.boSolution.children[0].euParameters[0].id
          paramVal1.duplicateDataType = this.boSolution.children[0].euParameters[0].dataType
          paramVal1.relationId = this.boSolution.children[0].euParameters[0].relationId
          paramVal1.dataType = this.boSolution.children[0].euParameters[0].dataType
          paramVal1.entityType = this.boSolution.children[0].euParameters[0].entityType
          paramVal1.entityId = this.boSolution.children[0].euParameters[0].entityId
          paramVal1.name = this.boSolution.children[0].euParameters[0].name
        }

        let paramVal2 = {}
        paramVal2.value = 1// Index[1] 固定为1（指分析次数）

        if (this.boSolution.children[0].euParameters !== undefined && this.boSolution.children[0].euParameters.length > 0) {
          let index = this.boSolution.children[0].euParameters.length === 1 ? 0 : 1
          paramVal2.parameterId = this.boSolution.children[0].euParameters[index].id
          paramVal2.relationId = this.boSolution.children[0].euParameters[index].relationId
          paramVal2.dataType = this.boSolution.children[0].euParameters[index].dataType
          paramVal2.duplicateDataType = this.boSolution.children[0].euParameters[index].dataType
          paramVal2.entityType = this.boSolution.children[0].euParameters[index].entityType
          paramVal2.entityId = this.boSolution.children[0].euParameters[index].entityId
          paramVal2.name = this.boSolution.children[0].euParameters[index].name
        }

        this.boSolution.children[0].parameterValues = []
        if (this.boSolution.children[0].euParameters.length === 2)
        {
          this.boSolution.children[0].parameterValues.push(paramVal1)
        }
        this.boSolution.children[0].parameterValues.push(paramVal2)

        // 如果是shortgun 和PRM 则无需prameterValues
        if (this.currEu === 'EU000048' || this.currEu === 'EU000046') {
          this.boSolution.children[0].parameterValues = []
        }
    },
    openPdfList() {
      wx.miniProgram.navigateTo({
        url: "/pages/pdf/pdfList?comeFrom=2"
      });
    },
    /**
     * 初始化正常购买基因数据结构
     */
    initNormalFormData () {
      this.initRadioTag()
      this.promotion = JSON.parse(localStorage.getItem('promotion'))
      this.productInfo = JSON.parse(localStorage.getItem('product'))
    },
    initOrderBasicData (data) {
      console.log(data, '解析后的数据')
      this.boSolution = data.boSolution
      this.productInfo = data.productInfo
      this.euTemplates = data.euTemplates
      this.puTemplates = data. puTemplates
      this.specPuTemplates = data.specPuTemplates
      this.deliveryTime = data.deliveryTime
      this.currEu = data.currEu
      this.currSku = data.currSku
      this.returnMaterialChecked = data.returnMaterialChecked
      if (data.oldCartContent) {
        this.oldCartContent = data.oldCartContent
      }
      this.promotion = data.promotion
      if (data.sampleType) {
        this.sampleType = data.sampleType.trim()
      }
      this.sampleSpecOptArr.some((item, index) => {
        if (item.engName === data.tax.dictValue) {
          this.sampleSpec = item.chnName
          this.sampleSpecItemChecked[index] = true
          // this.pickSampleSpec(index)
          return true
        }
      })
      this.diseaseDirectionName = data.diseaseDirection.name
      this.diseaseDirectionId = data.diseaseDirection.id
      this.otherSampleSpecName = data.otherTaxName
      if (this.otherSampleSpecName) {
        this.showOtherSampleSpecInput = true
      }
    },
    initOrderGroupData (data) {
      this.experimentalGroup = []
      data.groups.forEach(item => {
        this.addExperimental(item.name, item.bioRepeatTimes)
      })
      console.log(data.controlGroups)
      data.controlGroups.forEach(item => {
        this.controlGroup.push({experimental: this.experimentalGroup.filter(v => v.label === item[0].trim())[0],
          control: this.experimentalGroup.filter(v => v.label === item[1].trim())[0]})
      })
    },
    initSampleCategory (data) {
      this.pickSampleCategory(data.singleMeteData.specCategorySuperIndex)
      this.pickSubCategory(data.singleMeteData.sampleCategoryIndex)
    },
    initOtherParamData (data) {
      this.geneSelectionGroup = data.geneSelectionGroup
      this.boSignalAnalysis = data.singleMeteData.paraBioAnalysis
      this.databaseBuildings = data.singleMeteData.paraConstructionTech
      this.sampleProcessing = data.singleMeteData.paraRemoveHAProtein
      this.getPreferPrice()
    },
    jumpToCart () {
      wx.miniProgram.reLaunch({url: '/pages/cart/cart?type=99'})
    }
  },
  computed: {
    ...mapState(["geneSearchResult","sessionInfo",]),
    ...mapGetters([
      // 映射 this.navTopLevel 为 store.state.navTopLevel
      'cartList', 'customerNo'
    ]),
  },
};
</script>
<style scoped>
.pager {
  width: 100vw;
  background-color: #fafafa;
  flex: auto;
  -webkit-flex: auto;
  position: fixed
}
.article {
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}
.article .flag {
  position: absolute; /*绝对定位*/
  left: -30px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  width: 90px;
  background-color: #5878fa;
  color: #fff;
  font-size: 12px;
}
.article .flag-left {
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg) scale(0.8, 0.8);
  left: -34px;
  top: -4px;
}
.container {
  background: #fff;
}
.bo-logo img {
  height: 48px;
}
.bo-title {
  padding: 0 10px;
  position: relative;
  top: -15px;
}
.bo-title div:first-child {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #424242;
  line-height: 24px;
}
.bo-title div:last-child {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5878fa;
  line-height: 14px;
}
.real-price {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #5878fa;
  line-height: 22px;
}

.sale-price {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 17px;
}

.deliver-text {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
}

.deliver-value {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 14px;
  background: #5878fa;
  border-radius: 10px;
  padding: 1px 5px;
}

.advertising-banner {
  background: #fe654d;
  padding: 3px 20px;
  left: 0;
  right: 0;
  position: relative;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 17px;
}
.step-wrapper {
  padding: 18px 15% 0;
}
.form-label {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #424242;
  line-height: 20px;
}
.warning-info {
  background-color: #f6f6f6;
  padding: 10px 15px;
  font-size: 12px;
  color: #ff0000;
}
.pop-title {
  margin: 10px 0;
  align-items: center;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
.item-title {
  margin: 5px 20px;
  font-size: 14px;
  font-weight: bold;
}
.pop-button-wrap {
  display: flex;
  width: 100%;
  position: absolute;
  bottom: 10px;
}
.pop-button {
  justify-content: center;
  align-items: center;
  margin: 10px 20px;
  width: 100%;
  height: 40px;
  background-color: #5d7bf2;
  border-radius: 20px;
  text-align: center;
}
.pop-button span {
  color: #ffffff;
  line-height: 40px;
  vertical-align: middle;
}
.radioTag {
  margin: 2px;
  padding: 2px 5px;
  border: 1px solid #efeef3;
  border-radius: 15px;
  text-align: center;
  align-items: center;
  color: #797979;
  background-color: #efeef3;
  font-size: 12px;
}
.radioTagChecked {
  margin: 2px;
  padding: 2px 5px;
  border: 1px solid #657ce1;
  border-radius: 15px;
  text-align: center;
  align-items: center;
  color: #657ce1;
  background-color: #e0ecfd;
  font-size: 12px;
}
.segment-wrap {
  margin: 0 10px;
}
.group-title {
  padding: 0 10px;
  font-family: PingFangSC-Regular;
  font-weight: lighter;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
}
.cell-group-wrap {
  padding: 10px 0;
  background-color: #ffffff;
  border-radius: 10px;
}
.cell-title {
  font-family: PingFangSC;
  font-size: 14px;
  font-color: #424242;
  font-weight: normal;
  line-height: 20px;
}
.cell-label {
  padding-left: 6px;
  font-family: PingFangSC;
  font-size: 12px;
  color: #424242;
  font-weight: normal;
  line-height: 20px;
}
.cell-content {
  padding-right: 5px;
  text-align: right;
  font-family: PingFangSC;
  font-size: 12px;
  color: #5878fa;
  font-weight: normal;
  line-height: 20px;
  text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
  white-space: nowrap; /*让文字不换行*/
  overflow: hidden; /*超出要隐藏*/
}
.select-group {
  width: 40%;
  border-radius: 5px;
  border: #efeef3 0.5px solid;
  padding: 5px;
  font-size: 12px;
  align-items: center;
  text-align: center;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fafafa url("../../../static/img/路径1.png") no-repeat 94%;
}
.cart {
  background: url("../../../static/img/购物车-1.png") no-repeat;
  background-size:100% 100%;
}
/**
 *其它参数使用的样式
 */
.g-body {
  text-align: center;
  padding: 10px 0;
}
/**

 *未选中时的样式
 */
.g-self {
  /*padding: 10px;*/
  margin: 10px;
  background: white;
  border-radius: 10px;
  border: 0.7px #EFEEF3 solid;
  position: relative;
}
/**
 *选中后的样式
 */
.s-self {
  margin: 10px;
  background: white;
  border-radius: 10px;
  color: #5878fa;
  border: 0.7px #5878fa solid;
  position: relative;
}
.main-title {
  font-size: 16px;
  padding:8px 0 0 0;
}
.small-title {
  font-size: 12px;
  padding:0 0 8px 0;
}
.bottom-button {
  margin-top: 15px;
  width: 48%;
  border-radius: 44px;
  border: 1px solid #5878fa;
  font-size: 14px;
}
.bottom-button-small {
  margin-top: 15px;
  width: 43%;
  border-radius: 44px;
  border: 1px solid #5878fa;
  font-size: 14px;
}
input:disabled {
  background-color: #f3f3f3;
  border: none;
  padding: 10px;
  border-radius: 5px;
}
/*禁用建库技术-DIA6时的样式*/
.inner {
  color: #979797;
  margin: 10px;
  background: white;
  border-radius: 10px;
  padding: 10px;
  border: 0.5px hsla(0, 0%, 100%, 0.3) solid;
  background: hsla(0, 0%, 100%, 0.3);
  pointer-events: none;
}
/*以下是修改vant自带的样式*/
.cancel-default-style /deep/.van-cell {
  padding: 0;
  color: black;
}
.cancel-default-style /deep/.van-field__control {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #5878fa;
  line-height: inherit;
  text-align: left;
  background-color: transparent;
  border: 0;
  resize: none;
}
.stepper /deep/.van-stepper__plus {
  color: #5878fa;
  font-weight: bolder;
}
.stepper /deep/.van-stepper__minus {
  color: #5878fa;
  font-weight: initial;
}
/deep/.van-badge {
   display: inline-block;
   box-sizing: border-box;
   min-width: 16px;
   padding: 0 3px;
   color: #fff;
   font-weight: 500;
   font-size: 12px;
   font-family: -apple-system-font,Helvetica Neue,Arial,sans-serif;
   line-height: 1.2;
   text-align: center;
   background-color: #FE654D;
   border: 1px solid #fff;
   border-radius: 999px;
 }
.badgev /deep/.van-badge--fixed {
  position: absolute;
  top: 5px;
  right: 10px;
  -webkit-transform: translate(50%,-50%);
  transform: translate(50%,-50%);
  -webkit-transform-origin: 100%;
  transform-origin: 100%;
}
.date-select /deep/.van-calendar__selected-day {
  width: 54px;
  height: 54px;
  color: #fff;
  background-color: #5878fa;
  border-radius: 4px;
}
.date-select /deep/.van-button--danger {
  color: #fff;
  background-color: #5878fa;
  border: 1px solid #5878fa;
}
.next-button-active {
  background: #5878fa;
  color: white;
  height: 35px;
}
.next-button-inactive {
  background: #F2F2F2;
  border-color: #F2F2F2;
  color: #DBDBDB;
  height: 35px;
  pointer-events: none;
}
.flex-grow-1{
  min-width: 0;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-flex-shrink: 1;
  -ms-flex-negative: 1;
  flex-shrink: 1;
}
.sample-wrapper {
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// BoSolution.vue?727a3b72